export default "__VITE_ASSET__4f663f31__"